import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
export function OpeningHook() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  return <section className="w-full bg-cream-100 py-16 md:py-24" ref={ref} data-id="element-215">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-216">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} data-id="element-217">
          <div className="w-16 h-1 bg-gold-500 mb-8" data-id="element-218" />

          <p className="font-body text-lg sm:text-xl text-gray-700 leading-relaxed mb-6" data-id="element-219">
            Ya lograste lo más difícil:{' '}
            <strong className="text-navy-900" data-id="element-220">
              tienes la visa en tu pasaporte.
            </strong>{' '}
            Pero ahora te enfrentas al verdadero reto. Estados Unidos es un país
            diseñado para quienes ya tienen un historial, y tú vas a llegar sin
            número de seguro social, sin puntaje de crédito y sin una dirección
            fija.
          </p>

          <p className="font-body text-lg sm:text-xl text-gray-700 leading-relaxed" data-id="element-221">
            Bajar del avión con tu familia y tus maletas es una de las
            experiencias más emocionantes de tu vida, pero también{' '}
            <strong className="text-navy-900" data-id="element-222">la más arriesgada.</strong> Sin un
            plan, los primeros 10 días en el país pueden convertirse en un caos
            de gastos innecesarios, trámites bloqueados y decisiones tomadas
            bajo la presión de la improvisación.
          </p>
        </motion.div>
      </div>
    </section>;
}